"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get COMPANY_FORM_NAME_MAX_LENGTH () {
        return COMPANY_FORM_NAME_MAX_LENGTH;
    },
    get GetCompanyReviewFormRequest () {
        return GetCompanyReviewFormRequest;
    },
    get PatchCompanyReviewFormRequest () {
        return PatchCompanyReviewFormRequest;
    },
    get PostCompanyReviewFormRequest () {
        return PostCompanyReviewFormRequest;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const COMPANY_FORM_NAME_MAX_LENGTH = 250;
const PostCompanyReviewFormRequest = _zod.z.object({
    name: _zod.z.string().min(1).max(COMPANY_FORM_NAME_MAX_LENGTH),
    questions: _zod.z.array(_models.ReviewQuestionModel.omit({
        _id: true,
        company: true
    }).extend({
        refId: _zod.z.string(),
        questions: _zod.z.array(_zod.z.object({
            refId: _zod.z.string(),
            weight: _zod.z.number().gt(0)
        })).optional()
    })).optional()
});
const SORT_DIRECTION = [
    "asc",
    "desc"
];
const SORT_KEYS = [
    "name",
    "created_at",
    "creator.name",
    "relatedWorkflowCount",
    "questionsCount",
    "updated_at",
    "updated_by.name"
];
const GetCompanyReviewFormRequest = _zod.z.object({
    search: _zod.z.string().optional(),
    // is string since it is in the search params, must parse it to number and default to 1
    page: _zod.z.string().transform((val)=>parseInt(val, 10)).optional().default("1"),
    limit: _zod.z.string().transform((val)=>parseInt(val, 10)).optional().default("25"),
    sort: _zod.z.enum(SORT_KEYS).optional().default("name"),
    direction: _zod.z.enum(SORT_DIRECTION).optional().default("asc")
});
const PatchCompanyReviewFormRequest = _zod.z.object({
    name: _zod.z.string().min(0).max(COMPANY_FORM_NAME_MAX_LENGTH).optional(),
    questions: _zod.z.array(_models.ReviewQuestionModel.omit({
        _id: true,
        company: true
    }).extend({
        refId: _zod.z.string(),
        questions: _zod.z.array(_zod.z.object({
            refId: _zod.z.string(),
            weight: _zod.z.number().gt(0)
        })).optional()
    }))
});
